import React from 'react'
import useAuthStore from '../../store/authStore.js'
import { useLanguage } from '../../i18n/index.jsx'

interface EndDemoButtonProps {
  triggerClassName?: string
  triggerStyle?: React.CSSProperties
}

export default function EndDemoButton({ triggerClassName = 'floating-action-btn', triggerStyle }: EndDemoButtonProps) {
  const { demoExpiresAt, logout } = useAuthStore()
  const { t } = useLanguage()

  if (!demoExpiresAt) return null

  return (
    <button
      className={triggerClassName}
      onClick={logout}
      style={{
        display: 'flex', alignItems: 'center', gap: 6,
        height: 36, padding: '0 14px', borderRadius: 'var(--radius-lg)',
        background: 'rgba(239, 68, 68, 0.15)', color: 'var(--danger)',
        border: '1px solid rgba(239, 68, 68, 0.3)',
        fontSize: 'var(--text-sm)', fontWeight: 600, cursor: 'pointer',
        boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
        transition: 'background 0.15s, color 0.15s, border-color 0.15s, transform 0.1s',
        pointerEvents: 'auto',
        ...triggerStyle,
      }}
      onMouseEnter={e => {
        e.currentTarget.style.background = 'rgba(239, 68, 68, 0.25)'
        e.currentTarget.style.borderColor = 'var(--danger)'
        e.currentTarget.style.transform = 'translateY(-1px)'
      }}
      onMouseLeave={e => {
        e.currentTarget.style.background = 'rgba(239, 68, 68, 0.15)'
        e.currentTarget.style.borderColor = 'rgba(239, 68, 68, 0.3)'
        e.currentTarget.style.transform = 'none'
      }}
      title={t('endDemo')}
    >
      <span style={{ fontSize: 'var(--text-md)' }}>&#x23FB;</span>
      {t('endDemo')}
    </button>
  )
}
